<script setup lang="ts">
import { computed } from 'vue';
import { EditableChip } from '@/design-system';
import type { ConditionFieldType } from '@/types/HookConditionTypes';

type PropsType = {
    mode?: 'chip' | 'input';
    data?: string;
    items?: ConditionFieldType[];
    loading?: boolean;
    autofocus?: boolean;
    autoOpenMenu?: boolean;
    autoCloseMenu?: boolean;
};

const props = withDefaults(defineProps<PropsType>(), {
    mode: 'chip',
    items: () => [],
    loading: false,
    autofocus: false,
    autoOpenMenu: false,
    autoCloseMenu: false,
});

const emit = defineEmits<{
    select: [fieldName: string];
    click: [];
    'update:menu': [value: boolean];
}>();

const fieldObject = computed((): ConditionFieldType | undefined => {
    if (!props.data) {
        return undefined;
    }

    return props.items.find(f => f.name === props.data) || undefined;
});

const displayText = computed(() => {
    return fieldObject.value?.label || props.data || '';
});

const handleSelect = (field: unknown) => {
    const selectedField = field as ConditionFieldType;
    emit('select', selectedField.name);
};

const handleClick = () => {
    emit('click');
};
const handleMenuToggle = (value: boolean) => {
    emit('update:menu', value);
};
</script>

<template>
    <EditableChip
        :mode="props.mode"
        type="field"
        :data="fieldObject"
        :display-text="displayText"
        :items="items"
        item-title="label"
        item-value="name"
        :loading="loading"
        :autofocus="autofocus"
        :auto-open-menu="autoOpenMenu"
        :auto-close-menu="autoCloseMenu"
        @select="handleSelect"
        @click="handleClick"
        @update:menu="handleMenuToggle"
    />
</template>
